export default __webpack_public_path__ + "static/media/Marker.3b33ad58.svg";